import type { RootState } from '@shared/stores/rootTypes';

const selectedProfileSelector = (state: RootState) => state.user.selectedProfile;
const loginDateSelector = (state: RootState) => state.user.loginDate;

export { loginDateSelector, selectedProfileSelector };
